@import "../../shared";

.form-label__container {
  margin-bottom: 0.4rem;
}

.form-label__container--center {
  text-align: center;
}

.form-label__label {
  color: $text-color;
  font-family: $font-stack;
  font-size: $font-size-default;
  font-weight: 600;
  letter-spacing: $letter-spacing-normal;
  line-height: $font-size-default;
}

.form-label__note {
  margin-left: 1.5rem;
  color: $light-grey;
  font-size: $font-size-small;
}

// .form-label__note {
//   position: absolute;
//   right: 0;
//   top: 0;
//   font-size: $font-size-small;
//   line-height: 2rem;
//   letter-spacing: $letter-spacing-normal;
//   color: $text-color-secondary;
// }
